<template>
  <transition name="fade">
    <!-- <div> -->
    <!-- <p>{{ next_scene }}</p> -->
    <Scene
      :id="scene_id"
      :title="scene.title"
      :media="scene.media"
      :trackPostTime="scene.trackPostTime"
      :cover="scene.cover"
      :nextPath="next_scene"
      ref="scene"
      />
  <!-- </div> -->
  </transition>
</template>

<script>
import { mapState } from 'vuex';
import Scene from '@/components/Scene.vue'

export default {
  name: 'SceneView',
  // beforeRouteEnter(to, from, next) {
  //   // called before the route that renders this component is confirmed.
  //   // does NOT have access to `this` component instance,
  //   // because it has not been created yet when this guard is called!
  //   console.log('beforeRouteEnter', to, from);
  //   next();
  // },
  // beforeRouteUpdate(to, from, next) {
  //   // react to route changes...
  //   // don't forget to call next()
  //   console.log('beforeRouteUpdate', to, from);
  //   this.play();
  //   next();
  // },
  components: {
    Scene,
  },
  props: {
    autoplay: {
      default: true,
      type: Boolean,
    }
  },
  data () {
    return {
    }
  },
  mounted: function () {
    console.log('SceneView mounted');
    this.delayplay();
  },
  watch: {
      $route(to, from) {
        // react to route changes...
        console.log("route changes", to, from);
        this.delayplay();
      }
    },
  methods: {
    delayplay() {
      console.log("SceneView.delayplay");
      if (this.autoplay) {
        this.$nextTick(() => {
          setTimeout(this.$refs.scene.play, 2000);
        })
      }
    }
  },
  computed: {
    scene_path() {
      return this.$route.params.id;
    },
    scene_id() {
      return this.$store.getters.scene_ids[this.scene_path-1]
    },
    scene() {
      return this.$store.getters.scenes[this.scene_path-1];
    },
    next_scene() {
      let next_idx = parseInt(this.scene_path,10)+1;
      if (next_idx <= this.$store.getters.scenes.length) {
        return "/scene/"+next_idx;
      } else {
        return "/credits";
      }
    },
    ...mapState(['scene_order']),
  }
}
</script>

<style scoped>
</style>